// extracted by mini-css-extract-plugin
export default {"Menu":"Menu_Menu","link":"Menu_link","noResults":"Menu_noResults Menu_Menu","noResultsTitle":"Menu_noResultsTitle","switchEntryType":"Menu_switchEntryType"};